const meters = {
  meters: {
    engineHours: {
      title: 'x-label:workflow2.meters.engine hours.engine hours',
      data: [
        { label: 'x-label:workflow2.meters.engine hours.hrs total', num: '0286.8' },
        { label: 'x-label:workflow2.meters.engine hours.hrs trip', invert: true, num: '0286.8' }
      ],
      resetText: [
        'x-label:workflow2.meters.engine hours.reset engine trip hours',
        'x-label:workflow2.meters.engine hours.are you sure?'
      ],
      routes: {
        left: 'meters/exit',
        right: 'meters/pto-hours'
      }
    },
    ptoHours: {
      title: 'x-label:workflow2.meters.pto hours.pto hours',
      data: [
        { label: 'x-label:workflow2.meters.pto hours.hrs total', num: '0282.4' },
        { label: 'x-label:workflow2.meters.pto hours.hrs trip', invert: true, num: '0282.4' }
      ],
      resetText: [
        'x-label:workflow2.meters.pto hours.reset pto trip hours',
        'x-label:workflow2.meters.pto hours.are you sure?'
      ],
      routes: {
        left: 'meters/engine-hours',
        right: 'meters/fuel-economy'
      }
    },
    fuelEconomy: {
      title: 'x-label:workflow2.meters.fuel economy.fuel economy',
      data: [
        { label: 'x-label:workflow2.meters.fuel economy.gal/hr', num: '1.08' },
        { label: 'x-label:workflow2.meters.fuel economy.l/hr', num: '4.11' }
      ],
      routes: {
        left: 'meters/pto-hours',
        right: 'meters/fuel-used'
      }
    },
    fuelUsed: {
      title: 'x-label:workflow2.meters.fuel used.fuel used',
      data: [
        { label: 'x-label:workflow2.meters.fuel used.gal', invert: true, num: '0311.8' },
        { label: 'x-label:workflow2.meters.fuel used.l', invert: true, num: '1180.0' }
      ],
      resetText: [
        'x-label:workflow2.meters.fuel used.reset fuel used',
        'x-label:workflow2.meters.fuel used.are you sure?'
      ],
      routes: {
        left: 'meters/fuel-economy',
        right: 'meters/trip-statistics'
      }
    },
    tripStatistics0: {
      title: 'x-label:workflow2.meters.trip statistics.trip statistics',
      data: [
        { label: 'x-label:workflow2.meters.trip statistics.view trip statistics' },
      ],
      routes: {
        left: 'meters/fuel-used',
        center: 'meters/trip-statistics/1',
        right: 'meters/exit'
      },
    },
    tripStatistics1: {
      title: 'x-label:workflow2.meters.trip statistics.trip statistics 1',
      data: [
        { label: 'x-label:workflow2.meters.trip statistics.trip statistics 1.engine hours', invert: true, num: '0.00' },
        { label: 'x-label:workflow2.meters.trip statistics.trip statistics 1.pto hours', invert: true, num: '0.00' },
        [
          { label: 'x-label:workflow2.meters.trip statistics.trip statistics 1.g', invert: true, num: '0.00' },
          { label: 'x-label:workflow2.meters.trip statistics.trip statistics 1.l', invert: true, num: '0.00' },
          { label: 'x-label:workflow2.meters.trip statistics.trip statistics 1.fuel used', invert: true }
        ]
      ],
      routes: {
        center: 'meters/trip-statistics/2',
      }
    },
    tripStatistics2: {
      title: 'x-label:workflow2.meters.trip statistics.trip statistics 2',
      data: [
        { label: 'x-label:workflow2.meters.trip statistics.trip statistics 2.engine hours', invert: true, num: '0.00' },
        { label: 'x-label:workflow2.meters.trip statistics.trip statistics 2.pto hours', invert: true, num: '0.00' },
        [
          { label: 'x-label:workflow2.meters.trip statistics.trip statistics 2.g', invert: true, num: '0.00' },
          { label: 'x-label:workflow2.meters.trip statistics.trip statistics 2.l', invert: true, num: '0.00' },
          { label: 'x-label:workflow2.meters.trip statistics.trip statistics 2.fuel used', invert: true }
        ]
      ],
      routes: {
        center: 'meters/trip-statistics/3',
      }
    },
    tripStatistics3: {
      title: 'x-label:workflow2.meters.trip statistics.trip statistics 3',
      data: [
        { label: 'x-label:workflow2.meters.trip statistics.trip statistics 3.engine hours', invert: true, num: '0.00' },
        { label: 'x-label:workflow2.meters.trip statistics.trip statistics 3.pto hours', invert: true, num: '0.00' },
        [
          { label: 'x-label:workflow2.meters.trip statistics.trip statistics 3.g', invert: true, num: '0.00' },
          { label: 'x-label:workflow2.meters.trip statistics.trip statistics 3.l', invert: true, num: '0.00' },
          { label: 'x-label:workflow2.meters.trip statistics.trip statistics 3.fuel used', invert: true }
        ]
      ],
      routes: {
        center: 'meters/trip-statistics/4',
      }
    },
    tripStatistics4: {
      title: 'x-label:workflow2.meters.trip statistics.trip statistics 4',
      data: [
        { label: 'x-label:workflow2.meters.trip statistics.trip statistics 4.engine hours', num: '286.8' },
        { label: 'x-label:workflow2.meters.trip statistics.trip statistics 4.pto hours', num: '282.4' },
        [
          { label: 'x-label:workflow2.meters.trip statistics.trip statistics 4.g', num: '311.8\xa0\xa0' },
          { label: 'x-label:workflow2.meters.trip statistics.trip statistics 4.l', num: '1180.2' },
          { label: 'x-label:workflow2.meters.trip statistics.trip statistics 4.fuel used' }
        ]
      ],
      routes: {
        center: 'meters/trip-statistics/5',
      }
    },
    tripStatistics5: {
      title: 'x-label:workflow2.meters.trip statistics.trip statistics 5',
      data: [
        { label: 'x-label:workflow2.meters.trip statistics.trip statistics 5.engine hours', invert: true, num: '0.00' },
        { label: 'x-label:workflow2.meters.trip statistics.trip statistics 5.pto hours', invert: true, num: '0.00' },
        [
          { label: 'x-label:workflow2.meters.trip statistics.trip statistics 5.g', invert: true, num: '0.00' },
          { label: 'x-label:workflow2.meters.trip statistics.trip statistics 5.l', invert: true, num: '0.00' },
          { label: 'x-label:workflow2.meters.trip statistics.trip statistics 5.fuel used', invert: true }
        ]
      ],
      routes: {
        center: 'meters/trip-statistics',
      }
    },
    exit: {
      title: 'x-label:workflow2.meters.exit.exit',
      routes: {
        left: 'meters/trip-statistics',
        right: 'meters/engine-hours'
      }
    }
  }
};

export default meters;



// WEBPACK FOOTER //
// ./src/screens/data/flow2/meters.js